export default "__VITE_ASSET__Cd2zJBKD__"